// src/components/OffCanvasMenu.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { IoCall } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { scAxiosAdmin } from "../..";

const SideDrawerMenus = () => {
  const [headerData, setHeaderData] = useState([]);
  useEffect(() => {
    const headerDataList = {
      ids: [31, 33, 34, 36],
    };
    const getHeaderData = (data) => {
      try {
        const req = scAxiosAdmin
          .post(`/settings/get_multiple`, headerDataList, {
            // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
            method: "get",
            headers: {
              Accept: "application/json",
              // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              // console.log('your log output',data)
              // setStaticPageData(data.data.data);
              setHeaderData(data.data);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getHeaderData();
  }, []);
  return (
    <div>
      {/* Offcanvas Container */}
      <div
        className="offcanvas offcanvas-start"
        style={{ width: "80%" }} // Take up 80% of the screen width
        tabIndex="-1"
        id="sideBarMenus"
        aria-labelledby="sideBarMenusLabel"
      >
        <div className="offcanvas-header">
          <img
            src="/assets/images/updated_logo.svg" // Logo here
            alt="Logo"
            style={{ width: "100px" }}
          />
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        {/* Menu Items */}
        <div className="offcanvas-body">
          <div className="list-group">
            <Link
              to="/"
              className="py-3 px-2 text-decoration-none"
              style={{
                borderTop: "2px solid #AF9763",
                borderBottom: "1px solid #AF9763",
                borderRight: "none",
                borderLeft: "none",
                color: "#AF9763",
                fontWeight: "500",
              }}
            >
              Home
            </Link>
            <Link
              to="/page/about"
              className="py-3 px-2 text-decoration-none"
              style={{
                borderTop: "1px solid #AF9763",
                borderBottom: "1px solid #AF9763",
                borderRight: "none",
                borderLeft: "none",
                color: "#AF9763",
                fontWeight: "500",
              }}
            >
              About Us
            </Link>
            <Link
              to="/pages/departments"
              className="py-3 px-2 text-decoration-none"
              style={{
                borderTop: "1px solid #AF9763",
                borderBottom: "1px solid #AF9763",
                borderRight: "none",
                borderLeft: "none",
                color: "#AF9763",
                fontWeight: "500",
              }}
            >
              Department
            </Link>
            <Link
              to="/pages/career"
              className="py-3 px-2 text-decoration-none"
              style={{
                borderTop: "1px solid #AF9763",
                borderBottom: "1px solid #AF9763",
                borderRight: "none",
                borderLeft: "none",
                color: "#AF9763",
                fontWeight: "500",
              }}
            >
              Career
            </Link>
            <Link
              to="/page/contact"
              className="py-3 px-2 text-decoration-none"
              style={{
                borderTop: "1px solid #AF9763",
                borderBottom: "2px solid #AF9763",
                borderRight: "none",
                borderLeft: "none",
                color: "#AF9763",
                fontWeight: "500",
              }}
            >
              Contact Us
            </Link>
          </div>

          {/* Images with Links */}
          <div className="d-flex justify-content-start gap-2 mt-4">
            <a
              href={`tel:${
                headerData.length > 0 && headerData[0].value
                  ? headerData[0].value
                  : "10666"
              }`}
              className="d-inline-block"
              style={{ width: "25%" }}
            >
              <img
                src="/assets/images/call_update.svg"
                alt="Image 1"
                style={{ width: "70%" }}
              />
            </a>
            <Link
              to="/pages/emergency"
              className="d-inline-block"
              style={{ width: "25%" }}
            >
              <img
                src="/assets/images/emargency_update.svg"
                alt="Image 2"
                style={{ width: "70%" }}
              />
            </Link>
            <Link to="/" className="d-inline-block" style={{ width: "25%" }}>
              <img
                src="/assets/images/jci-gold-seal 1.png"
                alt="Image 3"
                style={{ width: "70%" }}
              />
            </Link>
          </div>

          {/* Contact Information */}
          <div className="mt-4" style={{ color: "#F58220" }}>
            <div className="d-flex justify-content-start gap-2 align-items-center mb-3">
              <TfiHeadphoneAlt />
              <p className="fw-bold">
                {headerData.length > 0 && headerData[0].value
                  ? headerData[0].value
                  : "10666"}
              </p>
            </div>
            <div className="d-flex justify-content-start gap-2 align-items-center mb-3">
              <IoCall />
              <p className="fw-bold">
                International:{" "}
                <span style={{ fontSize: "12px" }}>
                  {headerData.length > 0 && headerData[1].value
                    ? headerData[1].value
                    : "+880 2-2222-62466"}
                </span>{" "}
              </p>
            </div>
            <div className="d-flex justify-content-start gap-2 align-items-center mb-3">
              <FaWhatsapp />
              <p className="fw-bold">
                WhatsApp:{" "}
                <span style={{ fontSize: "12px" }}>
                  {headerData.length > 0 && headerData[2].value
                    ? headerData[2].value
                    : "+880191-4001214"}
                </span>{" "}
              </p>
            </div>
            <a
              href={
                headerData.length > 0 && headerData[3].value
                  ? headerData[3].value
                  : "https://maps.app.goo.gl/UJS8gnWhCddNuwDH9"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              <div
                style={{ color: "#F58220" }}
                className="d-flex justify-content-start gap-2 align-items-center"
              >
                <FaLocationDot />

                <p className="fw-bold">View Location </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideDrawerMenus;



// WEBPACK FOOTER //
// ./src/component/frontend/SideDrawerMenus.js